import { Injectable } from '@angular/core';
import { VwFindMyformControllerService } from 'src/app/sdk/services/vw-find-myform-controller.service';

@Injectable({
  providedIn: 'root'
})
export class VwFindMyFormService {

  constructor(
    private vwFindMyformService: VwFindMyformControllerService
  ) { }

  countStatus(emplidValue:string) {
    return this.vwFindMyformService.countStatus({ emplid: emplidValue }).toPromise();
  }

  findMyFormData(bodyObject:{}) {
    return this.vwFindMyformService.findMyFormData({body:bodyObject}).toPromise();
  }
}
